import type { QueryClient } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { invalidateAssignedAgents } from "web_myplann/Api/Advisor/invalidateAssignedAgents";
import { removeAdvisorFromCache } from "web_myplann/Api/Advisor/removeAdvisorFromCache";
import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";
import { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const removePendingAdvisorAndInvalidate = (
	queryClient: QueryClient,
	advisorId: number,
) => {
	queryClient.setQueryData<AssignedAgentsQueryData>(
		AdvisorKeys.assignedAgents(UserAgentStatusEnum.PendingClient),
		(cached) => removeAdvisorFromCache(cached, advisorId),
	);

	return invalidateAssignedAgents(queryClient);
};
